import * as fullStory from 'js/lib/fullstory';

import DegreesGrowthEpicClient from 'bundles/epic/clients/DegreesGrowth';

export const initFullStorySession = (slug: string) => {
  if (DegreesGrowthEpicClient.get('enableFullStoryDegreeDescriptionPage')) {
    fullStory.start();
    fullStory.set({
      slug,
      pageType: 'degree-description',
    });
  }
};
